// eslint-disable-next-line import/prefer-default-export
export function state(initialState = {}) {
  return (
    initialState.content || {
      details: {},
    }
  );
}
